import * as React from 'react';

import {
  createStyles,
  Grid,
  Theme,
  Typography,
  withStyles,
  WithStyles,
} from '@nelnet/unifi-components-react';

const styles = ({ breakpoints, spacing }: Theme) =>
  createStyles({
    skipLinkWrap: {
      position: 'relative',
      zIndex: 1200,
      '& a': {
        position: 'absolute',
        left: '-10000px',
        top: 'auto',
        width: '1px',
        height: '1px',
        overflow: 'hidden',
        '&:focus': {
          position: 'static',
          width: 'auto',
          height: 'auto',
          lineHeight: '1.5',
          marginLeft: spacing(2),
          [breakpoints.up('md')]: {
            marginLeft: '295px',
          },
        },
      },
    },
  });

type SkipLinkProps = WithStyles<typeof styles>;

const SkipLink: React.FunctionComponent<SkipLinkProps> = ({ classes }) => {
  const [headingRef, setHeadingRef] = React.useState(undefined);

  React.useEffect(() => {
    const element = document.querySelector('h1');

    if (element) {
      setHeadingRef(element);
    }
  }, []);

  const focusMain = () => {
    return headingRef && headingRef.focus();
  };

  return (
    <Grid container className={classes.skipLinkWrap}>
      <Grid item xs="auto" component={({ children }) => <Typography>{children}</Typography>}>
        <a href="#main" onClick={focusMain}>
          Skip to main content
        </a>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(SkipLink);
